import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { EnvironmentObject } from '../../consts/environment-object.token';
import { EnvironmentInterface } from '../../interfaces/environment.interface';
import { DEFAULT_API_ENDPOINTS } from '../../consts/default-api-endpoints';
import { mergeDeep } from '../../functions/util-functions';

@Injectable()
export class EnvironmentService implements EnvironmentInterface {
    public production?: boolean;
    public localAssets?: boolean;
    private _$environment: BehaviorSubject<EnvironmentInterface> = new BehaviorSubject(null);

    private _urls: { preview?: string; www?: string; edit?: string } = {};

    constructor(@Inject(EnvironmentObject) env: EnvironmentInterface) {
        this.environment = env;
    }

    public defineUrls(value: { preview: string; www: string; edit: string }) {
        this._urls = { ...value };
    }

    public get urlWWW(): string {
        return this._urls.www || null;
    }

    public get urlPreview(): string {
        return this._urls.preview || null;
    }

    public get urlEdit(): string {
        return this._urls.edit || null;
    }

    public set environment(val: EnvironmentInterface) {
        const _env = this._extendEnvironment(val);
        for (const key in _env) {
            if (_env.hasOwnProperty(key)) {
                if (key === 'getApiEndpoints') {
                    if (this['apiEndpoints'] == null) {
                        Object.defineProperty(this, 'apiEndpoints', {
                            get: () => {
                                return this.environment.getApiEndpoints();
                            }
                        });
                    }
                } else {
                    if (this[key] == null) {
                        Object.defineProperty(this, key, {
                            get: () => {
                                return this.environment[key];
                            }
                        });
                    }
                }
            }
        }
        this._$environment.next(_env);
    }
    public get environment(): EnvironmentInterface {
        return this._$environment.getValue();
    }
    public get environment$(): Observable<EnvironmentInterface> {
        return this._$environment.asObservable();
    }

    private _extendEnvironment(env: EnvironmentInterface): EnvironmentInterface {
        const _env = Object.assign({}, this.environment, env);

        let _envApiEndpoints = {};
        if (_env.getApiEndpoints != null) {
            _envApiEndpoints = _env.getApiEndpoints();
        }

        _env.getApiEndpoints = () => {
            return mergeDeep({}, DEFAULT_API_ENDPOINTS, _envApiEndpoints);
        };
        return _env;
    }
}
